'use strict';

goog.provide("Ntry.LmsJrResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.LmsJrResult = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
};

(function(p) {
    p.loadConfig = function() {
        Ntry.addEventListener("complete", this, this.complete);
    };

    p.complete = function(success, cause) {
        if(success) {
            // alert('성공');
            entrylms.emit('ExitStudy', {
                category: 'maze',
            });
        } else {
            // alert('실패' + cause);
        }
    };
})(Ntry.LmsJrResult.prototype);
